type LOCAL_DATA_KEYS = 'skechfab_code' | 'thumbnail_edit' | 'workspace_scale' | "payment_back_page";
export class SessionMemory {
  private constructor() {
    //
  }

  static get instance(): SessionMemory {
    return new SessionMemory();
  }

  setSession(key: LOCAL_DATA_KEYS, value: string | number | boolean): void {
    sessionStorage.setItem(key, value.toString());
  }

  getSession(key: LOCAL_DATA_KEYS): string {
    return sessionStorage.getItem(key);
  }

  removeSession(key: LOCAL_DATA_KEYS): void {
    sessionStorage.removeItem(key);
  }

  existsKey(key: LOCAL_DATA_KEYS): boolean {
    for (let i = 0; i < sessionStorage.length; i++) {
      if (key === sessionStorage.key(i)) {
        return true;
      }
    }
    return false;
  }

  set paymentBackPage(fromUrl: string) {
    this.setSession('payment_back_page', fromUrl);
  }

  get paymentBackPage(): string {
    return this.getSession('payment_back_page') as string;
  }



  set skechFabAuthCode(code: string) {
    this.setSession('skechfab_code', code);
  }

  get skechFabAuthCode(): string {
    return this.getSession('skechfab_code') as string;
  }

  get existsSkechFabAuthCode(): boolean {
    return this.existsKey('skechfab_code');
  }

  set thumbnailEditTarget(path: string) {
    this.setSession('thumbnail_edit', path);
  }

  get thumbnailEditTarget(): string {
    return this.getSession('thumbnail_edit');
  }
}
